/* Find your trailer: load capacity, a draggable strip, and a two step card.

   THINGS A STYLESHEET CANNOT DO.

   1. LOAD CAPACITY. The selector matrix the extension ships to the page
      carries deck and overall dimensions and no weights at all, so the picked
      card could only ever show two numbers. The figure does exist: the app
      proxy serves every model's spec groups at /apps/vin-search/modelSpecs,
      which is the same source the modal's Weight Ratings accordion reads and
      is cached server side. One GET on first paint, then a name lookup.

   2. DRAGGING THE STRIP. .ident-scroller is overflow-x: auto with no pointer
      handling and the rail under it had none either, so on a desktop the
      cursor said grab and neither the cards nor the rail moved. Snap is
      suspended while the button is down and restored on release, which lands
      the nearest card.

      MOUSE EVENTS, NOT POINTER EVENTS. The first attempt used pointerdown,
      pointermove and setPointerCapture, which is the modern spelling and
      silently did nothing: a drag that arrives as a mousedown, one mousemove
      and a mouseup never produces the pointermove stream that version was
      waiting on. mousedown and mousemove are fired by every real mouse and by
      everything that automates one. Touch is excluded by reading pointerType
      off the pointerdown that precedes each mousedown, so native touch
      scrolling, which was already correct, is left alone.

   3. TWO STEP SELECTION. One click used to open the model sheet outright.
      Now the first click marks the card and the second opens the sheet, so a
      customer can move along the row deciding before committing.

   4. CLOSING THE CHIP SHEET. The pill was the only thing that could close it.

   Nothing here assumes the extension's markup survives a re render: every
   binding is idempotent and a single observer repaints after the extension
   rebuilds. */
(function () {
  'use strict';

  var SPECS_URL = '/apps/vin-search/modelSpecs';
  var caps = null;
  var capsAsked = false;
  var lastPaint = '';
  var frame = 0;

  function key(s) {
    return String(s || '').toUpperCase().replace(/[^A-Z0-9]+/g, ' ').trim();
  }

  function loadCaps(done) {
    if (caps || capsAsked) { if (caps) done(); return; }
    capsAsked = true;
    fetch(SPECS_URL, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        caps = {};
        ((j && j.specs) || []).forEach(function (m) {
          (m.groups || []).forEach(function (g) {
            (g.rows || []).forEach(function (row) {
              if (/load\s*capacity/i.test(row.label || '')) {
                caps[key(m.modelName)] = String(row.value || '').trim();
              }
            });
          });
        });
        done();
      })
      .catch(function () { caps = {}; });
  }

  /* The rail names the trailer "SHIFTR 1883" and the spec sheet files it
     under "SHIFTR", so an exact lookup found nothing and the SHIFTR card was
     the only one with two figures. An exact name still wins; failing that,
     the longest spec name found in the rail name as whole words. Same rule
     fx-render.js uses for the renders. A model with no Load Capacity row
     (ENCLOSED) still shows none: nothing is made up. */
  function capFor(k) {
    if (!k) return '';
    if (caps[k]) return caps[k];
    var hay = ' ' + k + ' ', best = '';
    for (var name in caps) {
      if (!Object.prototype.hasOwnProperty.call(caps, name)) continue;
      if (name && name.length > best.length && hay.indexOf(' ' + name + ' ') !== -1) best = name;
    }
    return best ? caps[best] : '';
  }

  function modelName() {
    var n = document.querySelector('.ident-preview .ident-preview-name');
    return n ? n.textContent : '';
  }

  /* A qualifier belongs on the label, not inside a 30px figure:
     "3,086 lbs (estimated)" becomes 3,086 lbs over "Load Capacity, estimated". */
  function split(raw) {
    var m = /^(.*?)\s*\(([^)]+)\)\s*$/.exec(raw);
    if (!m) return { figure: raw, label: 'Load Capacity' };
    return { figure: m[1].trim(), label: 'Load Capacity, ' + m[2].trim() };
  }

  function sync() {
    var dims = document.querySelector('.ident-preview .ident-preview-dims');
    if (!dims) return;
    if (!caps) { loadCaps(sync); return; }

    var k = key(modelName());
    var raw = capFor(k);
    var cell = dims.querySelector('[data-fx-cap]');
    var sig = k + '|' + raw;
    if (sig === lastPaint && (raw ? !!cell : !cell)) return;
    lastPaint = sig;

    if (!raw) { if (cell) cell.parentNode.removeChild(cell); return; }

    var parts = split(raw);
    if (!cell) {
      cell = document.createElement('div');
      cell.setAttribute('data-fx-cap', '');
      dims.appendChild(cell);
    }
    /* Label first, figure second. The cell is column-reverse, so the figure
       renders above the label without the extension's markup changing. */
    cell.textContent = '';
    cell.appendChild(document.createTextNode(parts.label));
    var b = document.createElement('b');
    b.textContent = parts.figure;
    cell.appendChild(b);
  }

  /* ---- the drag ---------------------------------------------------- */

  var lastPointerType = 'mouse';
  document.addEventListener('pointerdown', function (e) {
    lastPointerType = e.pointerType || 'mouse';
  }, true);

  function swallow(e) { e.preventDefault(); e.stopPropagation(); }

  function bindDrag(el) {
    if (el.getAttribute('data-fx-drag')) return;
    el.setAttribute('data-fx-drag', '1');

    var down = false, travelled = 0, startX = 0, startLeft = 0;

    function move(e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) < 4 && !travelled) return;
      if (!travelled) {
        el.classList.add('is-dragging');
        el.style.scrollSnapType = 'none';
      }
      travelled = Math.max(travelled, Math.abs(dx));
      el.scrollLeft = startLeft - dx;
      e.preventDefault();
    }

    function end() {
      if (!down) return;
      down = false;
      window.removeEventListener('mousemove', move, true);
      window.removeEventListener('mouseup', end, true);
      el.classList.remove('is-dragging');
      el.style.scrollSnapType = '';
      if (travelled > 6) {
        /* The click the browser fires after a drag would otherwise pick a
           card the customer was only scrolling past. */
        el.addEventListener('click', swallow, true);
        setTimeout(function () { el.removeEventListener('click', swallow, true); }, 0);
      }
    }

    el.addEventListener('mousedown', function (e) {
      if (e.button !== 0 || lastPointerType === 'touch') return;
      down = true;
      travelled = 0;
      startX = e.clientX;
      startLeft = el.scrollLeft;
      window.addEventListener('mousemove', move, true);
      window.addEventListener('mouseup', end, true);
    });

    el.addEventListener('dragstart', function (e) { if (down) e.preventDefault(); });
  }

  /* ---- the rail under the strip ------------------------------------
     A 6px bar with a thumb, and until now nothing listened to it: the cursor
     said grab and the pointer did nothing. Dragging the thumb maps straight
     onto scrollLeft, and a click anywhere on the track jumps there, which is
     how every scrollbar a customer has ever used behaves.

     The rail is a sibling of .ident-strip inside .vin-hero-ident rather than a
     child of it, so the scroller is found from the shared parent. */
  function bindRail(rail) {
    if (rail.getAttribute('data-fx-rail')) return;
    rail.setAttribute('data-fx-rail', '1');

    var host = rail.parentElement;
    var down = false;

    function scroller() {
      return host ? host.querySelector('.ident-scroller') : null;
    }

    function seek(clientX) {
      var el = scroller();
      if (!el) return;
      var track = rail.getBoundingClientRect();
      var thumb = rail.firstElementChild;
      var tw = thumb ? thumb.getBoundingClientRect().width : 0;
      var run = track.width - tw;
      if (run <= 0) return;
      var ratio = (clientX - track.left - tw / 2) / run;
      ratio = Math.max(0, Math.min(1, ratio));
      el.style.scrollSnapType = 'none';
      el.scrollLeft = ratio * (el.scrollWidth - el.clientWidth);
    }

    function move(e) { if (down) { seek(e.clientX); e.preventDefault(); } }

    function end() {
      if (!down) return;
      down = false;
      window.removeEventListener('mousemove', move, true);
      window.removeEventListener('mouseup', end, true);
      rail.classList.remove('is-dragging');
      var el = scroller();
      if (el) el.style.scrollSnapType = '';
    }

    rail.addEventListener('mousedown', function (e) {
      if (e.button !== 0 || lastPointerType === 'touch') return;
      down = true;
      rail.classList.add('is-dragging');
      seek(e.clientX);
      window.addEventListener('mousemove', move, true);
      window.addEventListener('mouseup', end, true);
      e.preventDefault();
    });
  }

  /* ---- the chip sheet closes when you click away --------------------
     The pill's own handler is what gets called, not the class, so whatever
     owns .is-open keeps its state in step. */
  document.addEventListener('mousedown', function (e) {
    var bar = document.querySelector('.vin-hero-pickbar.fx-pb.is-open');
    if (!bar || bar.contains(e.target)) return;
    var pill = bar.querySelector('.fx-pb__pill');
    if (pill) pill.click();
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var bar = document.querySelector('.vin-hero-pickbar.fx-pb.is-open');
    if (!bar) return;
    var pill = bar.querySelector('.fx-pb__pill');
    if (pill) { pill.click(); pill.focus(); }
  });

  function bindAll() {
    var list = document.querySelectorAll('.ident-scroller');
    for (var i = 0; i < list.length; i++) bindDrag(list[i]);
    var rails = document.querySelectorAll('.ident-rail');
    for (var j = 0; j < rails.length; j++) bindRail(rails[j]);
  }

  /* ---- first click selects, second click opens ---------------------- */

  document.addEventListener('click', function (e) {
    var t = e.target;
    var card = t && t.closest ? t.closest('.ident-card') : null;
    if (!card) return;
    var row = card.closest('.ident-scroller') || card.closest('.ident-strip');
    if (!row) return;
    if (card.classList.contains('is-picked')) return;

    e.preventDefault();
    e.stopPropagation();

    var sibs = row.querySelectorAll('.ident-card.is-picked');
    for (var i = 0; i < sibs.length; i++) {
      sibs[i].classList.remove('is-picked');
      sibs[i].removeAttribute('aria-pressed');
    }
    card.classList.add('is-picked');
    card.setAttribute('aria-pressed', 'true');
  }, true);

  /* ---- keep up with the extension ----------------------------------- */

  function tick() {
    frame = 0;
    bindAll();
    sync();
  }

  function schedule() {
    if (frame) return;
    frame = requestAnimationFrame(tick);
  }

  function start() {
    tick();
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
